import { createFileRoute } from '@tanstack/react-router';

import { AiProposalReviewPage } from '../features/ai/ai-proposal-review-page';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/ai-proposals/$proposalId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { companySlug, projectId, proposalId } = Route.useParams();
  return (
    <AiProposalReviewPage companySlug={companySlug} projectId={projectId} proposalId={proposalId} />
  );
}
